import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { RegisterPage } from './pages/RegisterPage';
import { LoginPage } from './pages/LoginPage';
import { DropdownProvider } from './components/ui/Dropdown';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { GlobalWebSocketManager } from './components/GlobalWebSocketManager';
import { useUser } from './hooks/useUser';
import { UserPage } from './pages/UserPage';
import { FAQPage } from './pages/FAQPage';
import { InstructionsPage } from './pages/InstructionsPage';
import { PricingPage } from './pages/PricingPage';
import { LinksPage } from './pages/LinksPage';
import { AdminPage } from './pages/AdminPage';
import { useSwipeNavigation } from './hooks/useSwipeNavigation';

function AppContent() {
  const { user } = useUser();
  const userId = user?.user_id ? parseInt(user.user_id) : null;

  // Активируем свайп-навигацию в PWA режиме
  useSwipeNavigation();

  // Определяем iPhone и добавляем класс к body, а также Safe Area блок
  useEffect(() => {
    if (/iPhone/i.test(navigator.userAgent)) {
      document.body.classList.add("is-iphone");
      
      // Добавляем Safe Area блок только на iPhone с Safe Area
      // Используем несколько попыток чтобы CSS переменные успели загрузиться
      const checkSafeArea = () => {
        const safeAreaTop = getComputedStyle(document.documentElement).getPropertyValue('--safe-area-top');
        console.log('Safe Area Top:', safeAreaTop); // Для отладки
        
        if (safeAreaTop && safeAreaTop !== '0px') {
          const safeAreaBlock = document.createElement('div');
          safeAreaBlock.className = 'safe-area-block';
          document.body.insertBefore(safeAreaBlock, document.body.firstChild);
          console.log('Safe Area block added'); // Для отладки
        } else {
          // Если Safe Area не определился, попробуем еще раз через 500ms
          setTimeout(checkSafeArea, 500);
        }
      };
      
      // Первая попытка через 100ms
      setTimeout(checkSafeArea, 100);
    }
  }, []);

  return (
    <DropdownProvider>
      <GlobalWebSocketManager userId={userId} />
      <div className="min-h-screen bg-background text-text">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/user" element={<UserPage />} />
          <Route path="/user/settings" element={<UserPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/instructions" element={<InstructionsPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/links" element={<LinksPage />} />
        </Routes>
      </div>
    </DropdownProvider>
  );
}

function App() {
  return (
    <Router>
      <WebSocketProvider>
        <AppContent />
      </WebSocketProvider>
    </Router>
  );
}

export default App; 